import React from "react";
import { useField } from "formik";
import MunicipalitySelectBox from "../MunicipalitySelectBox";

const FormMunicipalitySelectBox = ({ name, onChange = null, ...rest }) => {
  const [field, meta, helpers] = useField(name);

  const getError = () => {
    if (!meta.touched || !meta.error) return null;
    if (Array.isArray(meta.error)) return meta.error.join(", ");
    return meta.error;
  };

  return (
    <MunicipalitySelectBox
      name={name}
      value={field.value}
      onChange={onChange ?? ((selected) => helpers.setValue(selected[0]))}
      error={getError()}
      {...rest}
    />
  );
};

export default FormMunicipalitySelectBox;
